export default "__VITE_ASSET__DPRADnc2__"